import { Object3D } from "three";
import { Visual } from "../models/Visual";
import { BaseVisual } from "./BaseVisual";
import * as THREE from "three";
import { copyToEuler, copyVec3 } from "./visual-utils";
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
export enum MarkerType {
  Poll = 'poll',
  FlatLabel = 'flat-label'
}

export interface MarkerVisualData extends Visual {
  type: MarkerType;
}

export class MarkerVisual extends BaseVisual implements MarkerVisualData {
  type: MarkerType = MarkerType.Poll;
  public container = new THREE.Group();
  protected async buildObj(): Promise<Object3D> {
    this.updateObj(); // Initialize the floor object
    return this.container;
  }
  
  public getType(): string {
    return 'MarkerVisual';
  }

  public updateObj(): void {
    // render polygon shape based on points
    copyVec3(this.position, this.container.position);
    copyToEuler(this.rotation, this.container.rotation);
    this.container.clear();
    const side = 0.3;
    const fontSize = side * 0.5;
    // estimate the length of the text
    const height = fontSize * this.id.length * 0.75 + 1.25;
    const barMaterial = new THREE.MeshStandardMaterial({
      color: 0x005f00,
      roughness: 0.5,
      metalness: 0.25,
      transparent: true,
      opacity: 0.75
    });
    const verticalBar = new THREE.Mesh(
      new THREE.BoxGeometry(side, side, height),
      barMaterial
    );
    verticalBar.position.set(0, 0, height * 0.5);
    for (let i = 0; i < 4; i++) {
      // if (i % 2 !== 0) {
      //   continue;
      // }
      const label = new THREE.Mesh(
        new TextGeometry(this.id, {
          font: this.wr.dataService.font,
          size: side * 0.5,
          depth: 0.005,
        }),
        new THREE.MeshStandardMaterial({ 
          color: 0xffffff,
          roughness: 0.5,
          metalness: 0.85
        })
      );
      label.rotation.x = Math.PI / 2;
      label.rotation.z = Math.PI / 2;
      label.rotation.y = i * (Math.PI / 2);
      const posVector = new THREE.Vector3(side * 0.25, -side * 0.5, -0.5 * height + 1.0);
      posVector.applyEuler(
        new THREE.Euler(0, 0, i * (Math.PI / 2))
      );
      label.position.copy(posVector);
      verticalBar.add(label);
    }
    const base = new THREE.Mesh(
      new THREE.CylinderGeometry(side * 1.5, side * 1.75, 0.1, 16),
      barMaterial
    );
    base.rotation.x = Math.PI / 2;
    base.position.z = -0.5 * height + 0.05;
    verticalBar.add(base);

    this.container.add(verticalBar);
  }

}
